import React from 'react';
import "bootstrap/scss/bootstrap.scss";
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import configureStore from './store';

const store= configureStore();

render(
  <Provider store={store}>
      <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
